import { createStyles, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'

interface IUsePickupDropoffSelectStylesProps {
  /**
   * @default false
   */
  enableAnyPickup?: boolean
  /**
   * @default false
   */
  enableAnyDropoff?: boolean
}

export const usePickupDropoffSelectStyles = ({
  enableAnyDropoff = false,
  enableAnyPickup = false,
}: IUsePickupDropoffSelectStylesProps) =>
  makeStyles(theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
      },
    },
    inputContainer: {
      flex: '1 0',
      margin: `0 0 ${theme.spacing(1.5)}`,

      [theme.breakpoints.up('lg')]: {
        margin: 0,
      },

      '&.pickup-input input': {
        '&::placeholder': {
          opacity: enableAnyPickup ? 1 : 0.5,
        },
        '&:focus::placeholder': {
          opacity: 0.5,
        },
      },

      '&.dropoff-input input': {
        '&::placeholder': {
          opacity: enableAnyDropoff ? 1 : 0.5,
        },
        '&:focus::placeholder': {
          opacity: 0.5,
        },
      },
    },
    swapButtonWrapper: {
      display: 'none',
      flex: '0 0 60px',
      justifyContent: 'center',
      alignItems: 'center',

      [theme.breakpoints.up('lg')]: {
        display: 'flex',
      },
    },
    radiusSelect: {
      flex: '0 0 105px',

      [theme.breakpoints.up('lg')]: {
        flex: '0 0 140px',
      },

      '& .MuiSelect-select': {
        backgroundColor: brandColors.coolGray1,
        borderTop: `0`,
        borderRight: `0px`,
        borderBottom: `1px solid ${brandColors.coolGray3}`,
        borderLeft: `1px solid ${brandColors.coolGray3}`,
        borderRadius: '0px',
        paddingTop: '7px',
        paddingBottom: '7px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: '0px',
        borderRadius: '0px',
      },
      '& .MuiSelect-icon': {
        color: brandColors.coolGray5,
      },
    },
  }))()

export const useAutocompleteLocationStyles = makeStyles(theme =>
  createStyles({
    inputRoot: {
      backgroundColor: brandColors.coolGray1,
      borderBottom: `1px solid ${brandColors.coolGray3}`,
      borderRadius: '0px',
      paddingTop: '3.5px !important',
      paddingBottom: '2.5px !important',
      paddingLeft: '6px !important',

      [theme.breakpoints.up('md')]: {
        paddingTop: '2.5px !important',
      },

      '&.Mui-error': {
        borderBottomColor: brandColors.error,
      },

      '&.Mui-focused': {
        borderRadius: '0px',
      },

      '&.MuiInputBase-adornedStart': {
        paddingLeft: '9px !important',

        '& .MuiInputAdornment-positionStart svg': {
          color: brandColors.black,
        },
      },

      // Small size
      '&.MuiOutlinedInput-sizeSmall': {
        paddingTop: '3.185px !important',
        paddingBottom: '3.185px !important',

        '&.MuiInputBase-adornedStart': {
          paddingLeft: '6px !important',
        },
      },

      // Input
      '& .MuiInputBase-input': {
        backgroundColor: brandColors.transparent,
      },

      // Input Outline
      '& .MuiOutlinedInput-notchedOutline': {
        border: `0px`,
      },
    },
    clearIndicator: {
      color: brandColors.coolGray5,

      '&:hover': {
        color: brandColors.coolGray5,
      },

      '.Mui-error &': {
        color: brandColors.error1,

        '&:hover': {
          color: brandColors.error1,
        },
      },
    },
    popupIndicator: {
      display: 'none',
    },
    endAdornment: {
      '.MuiOutlinedInput-sizeSmall &': {
        top: 'calc(50% - 12px)',
      },
    },
  })
)
